// extracted by mini-css-extract-plugin
export default {"container":"go-z","ratingLayout":"ho-z","ratingLabel":"io-z","nonInteractiveRatingLabel":"jo-z"};